export default function ({ user, likes }) {
  if (!likes || likes.length === 0) return false;

  if (likes.some((like) => like && like.id === user.id)) {
    return true;
  } else {
    return false;
  }
}
